import { v4 as uuidv4 } from "uuid";

export function createElementFromDrag(data) {
  const base = {
    id: uuidv4(),
    x: 40,
    y: 40,
    width: 160,
    height: 30,
    style: {
      fontSize: 12,
      bold: false,
      color: "text.primary",
      backgroundColor: "transparent",
      textAlign: "left",
      verticalAlign: "top"
    }
  };

  if (data.type === "field" && data.fieldPath?.toLowerCase() === "entity.slogo") {
    return {
      ...base,
      type: "field",
      label: data.label,
      fieldPath: data.fieldPath,
      sourceSection: data.sourceSection,
      width: 120,
      height: 60
    };
  }

  if (data.type === "field") {
    return {
      ...base,
      type: "field",
      label: data.label,
      fieldPath: data.fieldPath,
      sourceSection: data.sourceSection,
      fieldType: data.fieldType,
      dataType: data.dataType,
      format: data.format || ""
    };
  }

  if (data.type === "label") {
    return {
      ...base,
      type: "label",
      text: data.text || "Label"
    };
  }

  if (data.type === "typography") {
    return {
      ...base,
      type: "typography",
      text: data.text || "Text",
      height: 40,
      style: {
        ...base.style,
        fontSize: 18,
        bold: true
      }
    };
  }

  if (data.type === "line") {
    return {
      ...base,
      type: "line",
      width: 300,
      height: 2
    };
  }

  if (data.type === "rectangle") {
    return {
      ...base,
      type: "rectangle",
      width: 200,
      height: 80
    };
  }

  if (data.type === "image") {
    return {
      ...base,
      type: "image",
      width: 120,
      height: 80,
      src: ""
    };
  }

  if (data.type === "table") {
    return {
      ...base,
      type: "table",
      width: 500,
      height: 160,
      sourceSection: "tabledetails",
      columns: []
    };
  }

  if (data.type === "transactionDetailTable") {
    return {
      ...base,
      type: "transactionDetailTable",
      label: "Transaction Detail Table",
      sourceSection: "tabledetails",
      width: 520,
      height: 180,
      showHeader: true,
      repeatHeaderOnPageBreak: true,
      headerHeight: 26,
      rowHeight: 24,
      columns: [],
      style: {
        ...base.style,
        fontSize: 12,
        border: true
      }
    };
  }

  if (data.type === "summaryBand") {
    return {
      ...base,
      type: "summaryBand",
      label: "Summary Band",
      x: 30,
      y: 430,
      width: 535,
      height: 120,
      band: "page",
      showOnEmpty: true,
      style: {
        ...base.style,
        backgroundColor: "transparent",
        border: true
      }
    };
  }

  if (data.type === "pageHeaderBand") {
    return {
      ...base,
      type: "pageHeaderBand",
      label: "Page Header",
      band: "page",
      x: 20,
      y: 20,
      width: 555,
      height: 80,
      repeatOnEveryPage: true,
      style: {
        ...base.style,
        backgroundColor: "transparent",
        border: true
      }
    };
  }

if (data.type === "pageFooterBand") {
  return {
    ...base,
    type: "pageFooterBand",
    label: "Page Footer",
    band: "page",
    x: 20,
    y: 782,
    width: 555,
    height: 40,
    repeatOnEveryPage: true,
    style: {
      ...base.style,
      backgroundColor: "transparent",
      border: true
    }
  };
}

if (data.type === "groupHeaderBand") {
  return {
    ...base,
    type: "groupHeaderBand",
    label: "Group Header",
    band: "page",
    x: 20,
    y: 310,
    width: 555,
    height: 30,
    groupFieldPath: "",
    repeatOnPageBreak: true,
    style: {
      ...base.style,
      backgroundColor: "transparent",
      border: true
    }
  };
}

if (data.type === "groupFooterBand") {
  return {
    ...base,
    type: "groupFooterBand",
    label: "Group Footer",
    band: "page",
    x: 20,
    y: 500,
    width: 555,
    height: 30,
    style: {
      ...base.style,
      backgroundColor: "transparent",
      border: true
    }
  };
}

  if (data.type === "summaryTaxList") {
    return {
      ...base,
      type: "summaryTaxList",
      label: data.label || "Tax List",
      fieldPath: data.fieldPath || "summary.summ_tax",
      sourceSection: "summary",
      width: 220,
      height: 24,
      rowHeight: 18,
      valueWidth: 80,
      showTaxCode: false,
      showTaxName: true,
      style: {
        ...base.style,
        fontSize: 10,
        textAlign: "left",
        verticalAlign: "middle"
      }
    };
  }

  if (data.type === "summaryWithholdingList") {
    return {
      ...base,
      type: "summaryWithholdingList",
      label: data.label || "Withholding Tax List",
      fieldPath:
        data.fieldPath || "summary.summ_withholding",
      sourceSection: "summary",
      width: 220,
      height: 24,
      rowHeight: 18,
      valueWidth: 80,
      showWithholdingCode: true,
      showWithholdingName: true,
      style: {
        ...base.style,
        fontSize: 10,
        textAlign: "left",
        verticalAlign: "middle"
      }
    };
  }
  return {
    ...base,
    type: "label",
    text: "New Element"
  };
}